module.exports = __webpack_public_path__ + "static/media/projekt_logo_veliki.38353d18.svg";